import SLPFormComponent, { SLpFormProps } from "pages/SLPForm";
import { connect, MapDispatchToProps } from "react-redux";
import { plaUserListRequest } from "store/slpDashboard/actions";
import {
  addEditGoalsAssessmentRequest,
  addPersonalAndSmartGoalsRequest,
  deletePersonalAndSmartGoalsRequest,
  getCurrentSLPGoalsPDFRequest,
  hopesGoalsAndAmbitionsRequest,
  personalAndSmartGoalsBySlpIdRequest,
  personalAndSmartGoalsRequest,
  updateHopesGoalsAndAmbitionsRequest,
  whereToFromHereRequest,
} from "store/slpForm/action";
import { getCurrentCoursesForAddEnrolmentRequest } from "store/student/action";
import {
  IHopesGoalsAndAmbitions,
  ISlpFormContainerDispatch,
} from "utils/interfaces/slp-form";

const mapDispatchToProps: MapDispatchToProps<
  ISlpFormContainerDispatch,
  IHopesGoalsAndAmbitions
> = {
  hopesGoalsAndAmbitionsRequest,
  updateHopesGoalsAndAmbitionsRequest,
  plaUserListRequest,
  personalAndSmartGoalsRequest,
  personalAndSmartGoalsBySlpIdRequest,
  addPersonalAndSmartGoalsRequest,
  addEditGoalsAssessmentRequest,
  deletePersonalAndSmartGoalsRequest,
  getCurrentSLPGoalsPDFRequest,
  getCurrentCoursesForAddEnrolmentRequest,
  whereToFromHereRequest,
};

const connector = connect(null, mapDispatchToProps);

const SLPForm: React.FC<SLpFormProps> = (props) => {
  return <SLPFormComponent {...props} />;
};

export default connector(SLPForm);
